module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fintech-solutions/fintech-solutions.component.css
// module id = ./src/app/components/fintech-solutions/fintech-solutions.component.css
// module chunks = main